import { ReactElement } from "react";
import {
	ActionListItem,
	DropOverActionList
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { OpenItemMenuState, useItemDropOverMenuProps } from "client/Hooks";

export type GroupItemMenuProps = {
	target: HTMLElement;
	onClose: () => void;
	menuState: OpenItemMenuState;
	name: string;
	onDelete: () => void;
};

export const GroupItemMenu = (props: GroupItemMenuProps): ReactElement => {
	const {
		target,
		onClose,
		menuState,
		name,
		onDelete
	} = props;

	const {
		targetAlignment,
		contentAlignment,
		closeOnMouseDown
	} = useItemDropOverMenuProps(
		menuState,
		{
			moreMenuContentAlignment: "tr",
			moreMenuTargetAlignment: "br"
		}
	);

	return (
		<DropOverActionList
			target={target}
			onClose={onClose}
			menuTitle={name}
			targetAlignment={targetAlignment}
			contentAlignment={contentAlignment}
			closeOnMouseDown={closeOnMouseDown}
		>
			<ActionListItem
				onClick={onDelete}
				text={localize("_Delete")}
				trackingId="delete-group"
				icon="trash-can"
			/>
		</DropOverActionList>
	);
};
GroupItemMenu.displayName = "GroupItemMenu";